const Logo = ({
  src,
  alt = "Logo",
  className = "w-20 h-auto",
  align,
  contactInfo = {
    address: "",
    suite: "",
    city: "",
    email: ""
  },
  showContact = false
}) => {
  return (
    <div
      className={
        align === "right"
          ? "flex flex-row w-full items-start justify-between"
          : "flex flex-row items-start justify-between"
      }
    >
      <img
        src={src}
        alt={alt}
        loading="eager"
        className={`${className} flex-shrink-0`}
      />

      {showContact && (
        <div className="text-xs text-gray-600 text-right flex-shrink-0">
          <p className="m-0 p-0 leading-tight">
            {contactInfo.address}
          </p>

          <p className="m-0 p-0 leading-tight">
            {contactInfo.suite}
          </p>

          <p className="m-0 p-0 leading-tight">
            {contactInfo.city}
          </p>

          <p className="m-0 p-0 leading-tight">
            {contactInfo.email}
          </p>
        </div>
      )}
    </div>
  );
};

export default Logo;